const commonZh = {
  zh: {
    common: {
      logout: '登出',
      change_password_button: '更改密碼',
      my_plan: '我的計劃',
      my_profile: '我的個人資料',
      message_box: '留言框',
      faq: '常見問題',
      contact_us: '聯絡我們',
      today: '今天',
      reset: '全部清除',
      submit: '提交',
      search: '搜尋',
      stage: '階段',
      status: '狀態',
      type: '服務種類',
      consultant: '顧問',
      search_rec_date: '申請書收到日期 (YYYY/MM/DD)',
      search_create_date: '新增日期 (YYYY/MM/DD)',
      search_complete_date: '完成日期 (YYYY/MM/DD)',
      included_team: '包含團隊',
      documents: {
        no_file_found: '沒有找到文件',
      },
      loading: '處理中...',
      sortable_column: '可排序列',
      please_select: '請選擇',
      close: '關閉',
      pdf_version: 'PDF版本',
      zip_version: 'ZIP',
      expand_tree: '展開',
      collapse_tree: '摺叠',
      pop_error: '通知',
      main_site_contact_us: '聯絡我們',
      main_site_privacy: '隱私權政策',
      main_site_disclaimer: '免責聲明',
      react_select_placeholder: '請選擇',
      per_page: '每頁',
      paginate_status: '顯示 {{from}} - {{to}}，共 {{size}} 項',
      cannot_be_blank: '不能空白',
    },
    models: {
      applications: {
        code: '顧問代號',
        name: '顧問名稱',
        action_type: '申請類別',
        product_provider: '產品公司',
        product_type: '產品類別',
        product_name: '產品名稱',
        has_riders: '包含附加保障',
      },
    },
    selection: {
      included_team: [['true', '是'], ['false', '否']],
      stage_type: [['nb', '處理中'], ['all', '全部'], ['select', '自訂']],
      stage_options: [
        ['', ' - 全部 - '],
        [1, '第一階段'],
        [2, '第二階段'],
        [3, '第三階段'],
        [4, '第四階段'],
        [5, '第五階段'],
        [6, '第六階段'],
        [7, '第七階段'],
        [8, '其他'],
      ],
      followup_type_options: [
        ['', ' - 全部 -'],
        [6, '欠款處理'],
        [7, '供款續期'],
      ],
      type_options: [
        ['', ' - 全部 - '],
        ['D', '代操服務'],
        ['N', '未使用代操服務'],
        ['T', 'TR-Discretionary'],
      ],
      report_date_options: [
        ['APPL', '申請書收到日期'],
        ['APPLSENT', '申請書送出日期'],
        ['POLICY', '計畫生效日'],
      ],
      client_date_options: [
        ['APPL', '申請書收到日期'],
        ['POLICY', '計畫生效日'],
      ],
      report_type_options: {
        'afs': [
          [1, '1. 保單中斷 / 贖回報表'],
          [2, '2. 新客戶報表'],
          [3, '3. 新件狀態報表'],
          [4, '4. 業績報表'],
          [5, '5. 轉入客戶報表'],
          [6, '6. 客戶生日報表'],
          [7, '7. 欠款報表'],
          [8, '8. 信用卡到期報表'],
          [9, '9. 客戶資產總值報表'],
          [10, '10. 保單資料報表'],
          [11, '11. 保單項目報表'],
          [12, '12. 保單持有人報表'],
          [13, '13. 保單 AB BV 報表'],
          [14, '14. 個人 AB BV 報表'],
          [201, '201. Training History Report'],
        ],
        'ipc': [
          [1, '1. 保單資料報表'],
          [2, '2. 保單項目報表'],
          [3, '3. 保單持有人報表'],
          [4, '4. 業績報表'],
          [5, '5. 客戶生日報表'],
        ],
        'absg': [
          [1, '1. 保單資料報表'],
          [2, '2. 保單項目報表'],
        ]
      },
      product_type_options: [
        ['', ' - 全部 - '],
        ['IL', '投資相連保險'],
        ['IN', '保險計劃'],
      ],
      exclude_status_options: [
        ['CAN', '取消'],
        ['COF', '冷靜期取消'],
        ['LAP', '保單中斷'],
        ['SUR', '贖回'],
        ['TOT', '轉出客戶'],
      ],
      lapsed_surrender_options: [
        ['', ' - 全部 - '],
        ['LAP', '保單中斷'],
        ['SUR', '贖回'],
      ],
      status_options: [['All', '- 全部 -'], ['O', '處理中'], ['C', '完成']],
      policy_status: [
        ['RCV', '送抵'],
        ['AIP', '處理中'],
        ['ACT', '審核完成'],
        ['CAN', '取消'],
        ['INF', '已生效'],
        ['COF', '冷靜期取消'],
        ['COD', '終止'],
        ['MAT', '保單期滿'],
        ['LAP', '保單中斷'],
        ['SUR', '贖回'],
        ['TOT', '轉出客戶'],
        ['OPN', '已生效'],
        ['CFM', ''],
        ['TER', '停效'],
      ],
      exclude_policy_status: [
        ['COD', '終止'],
        ['CAN', '取消'],
        ['COF', '冷靜期取消'],
        ['LAP', '保單中斷'],
        ['SUR', '贖回'],
        ['TOT', '轉出客戶'],
        ['TER', '停效'],
      ],
      product_type: [
        ['IL', '投資相連保險'],
        ['IN', '保險計劃'],
        ['FD', '投資'],
        ['GI', '一般保險'],
        ['MPF', '強積金'],
        ['PB', '私人理財'],
        ['TU', '信託'],
      ],
      b2b_product_type: [
        ['IL', '投資相連保險'],
        ['IN', '保險計劃'],
        ['FD', '投資'],
        ['GI', '一般保險'],
        ['MPF', '強積金'],
        ['PB', '私人理財'],
        ['TU', '信託'],
      ],
      applicants: {
        1: '第一申請人',
        2: '第二申請人',
        3: '第三申請人',
        4: '第四申請人',
        5: '第五申請人',
      },
      yes_no: {
        1: '是',
        0: '否',
      },
      product_action: {
        NB: '新單',
        PI: '增加供款',
        TI: '更改介紹人',
        AM: '轉讓',
      },
    },
    login: {
      select_area: '請選擇 :',
      select_client: '客戶登入',
      select_producer: '合作伙伴登入',
      login_btn: '登入',
      login: '登入賬號',
      login_b2b: '登入賬號',
      password: '密碼',
      loginHelpB2c: '您的ID是一個8位數字，以“AG”開頭，例如 AG12345678',
      passwordHelpB2c: '密碼為6到10個字符',
      loginWording: '訪問此登錄區域即表示您同意和接受我們的 ',
      disclaimer: '條款',
      and: ' 和 ',
      privacyPolicy: '隱私政策',
      loginWording2: '',
      newUser: '新用戶?',
      activateYourAccount: '啟動您的帳戶',
      newUser2: '',
      cannotLogin: '未能登入?',
      cannotLogin_b2b: '未能登入?',
      forgetLoginIdPassword: '忘記帳號 / 密碼',
      cannotLogin2: '',
      forgetPassword: '忘記密碼',
      needHelp: '需要幫忙？',
      needHelpPlease: '需要幫忙？ 請與',
      faq_1: '查看帳戶註冊和登錄的',
      faq_2: ' 常見問題 ',
      faq_3: '',
      needAssistant: '如果您需要幫助，請與',
      contactUs: '我們聯絡',
      inquiry_1: '',
      inquiry_2: '',
    },
    activation: {
      login_id: '登入帳號',
      identification_number: '證件號碼 / 登入ID',
      identification_number_placeholder: '身份證號碼 / 護照號碼 / 商業登記 / AGXXXXXXXX',
      identification_number_tooptip_text: '請參閱歡迎信件或對賬單上所顯示之客戶 ID (AGxxxxxx)',
      date_of_birth: '生日',
      code: '啟用碼',
      new_password: '密碼',
      password_confirmation: '請再輸入一次密碼',
      submit: '送出',
      online_reg_title: '線上申請帳號註冊',
      reg_sub_title: '身份認證',
      reg_form_head_title: '請輸入您的個人資訊',
      dd: 'DD',
      mm: 'MM',
      yyyy: 'YYYY',

      with_email: {
        sub_title: '帳號申請連結已發送！',
        content_line1: '連結已發送到您註冊的電郵地址 {{email}}，',
        content_line2: '請按照電郵中的指示啟動帳號。',
        content_line3: '如果您在接下來的30分鐘內未收到我們的電郵，',
        content_line4: '請點擊以下按鈕。',
      },
      without_email: {
        sub_title: '找不到相符的電郵地址',
        content_line1: '您輸入的電郵地址與我們記錄不符。要重新登記電郵地址，請填寫',
        content_line2: '',
        content_form_name: '"更改聯絡資料表格"',
        content_line3: ' 並電郵到 ',
        content_line4: '如有任何疑問，請聯絡您的客戶經理或',
        content_line5: '按此',
      },

      activate_sub_title: '請先設定密碼',
      activate_success_sub_title: '線上註冊帳號成功建立',
      activate_success_content_line1: '帳號成功建立',
      activate_success_content_line2: '請使用帳號 {{loginId}} 以作登入。',
      go_to_login: '回到登入頁面',
      send_again: '請求再次寄送',
    },
    forget_password: {
      login_id: '登入帳號',
      login_id_b2b: '登入帳號',
      identification_number: '證件號碼 / 登入ID',
      identification_number_placeholder: '身份證號碼 / 護照號碼 / 商業登記 / AGXXXXXXXX',
      identification_number_tooptip_text: '請參閱歡迎信件或對賬單上所顯示之客戶 ID (AGxxxxxx)',
      date_of_birth: '生日',
      code: '啟用碼',
      submit: '送出',
      title: '忘記帳號 / 密碼',
      title_b2b: '忘記密碼',
      sub_title: '身份認證',
      form_head_title: '請輸入您的個人資訊',
      form_head_title_b2b: '請輸入您的個人資訊',
      go_to_login: '回到登入頁面',
      send_again: '請求再次寄送',
      dd: 'DD',
      mm: 'MM',
      yyyy: 'YYYY',

      with_email: {
        sub_title: '重啟帳號連結已發送！',
        content_line1: '連結已發送到您註冊的電郵地址 {{email}}，',
        content_line2: '請按照電郵中的指示重啟帳號。',
        content_line3: '如果您在接下來的30分鐘內未收到我們的電郵，',
        content_line4: '請點擊以下按鈕。',
      },
      without_email: {
        sub_title: '找不到相符的電郵地址',
        content_line1: '您輸入的電郵地址與我們記錄不符。要重新登記電郵地址，請填寫',
        content_line2: '',
        content_form_name: '"更改聯絡資料表格"',
        content_line3: ' 並電郵到 ',
        content_line4: '如有任何疑問，請聯絡您的客戶經理或',
        content_line5: '按此',
      },
      reset_password: {
        title: '忘記帳號 / 密碼',
        title_b2b: '忘記帳號 / 密碼',
        sub_title: '請先重設密碼',
        login_id: '登入帳號',
        login_id_b2b: '登入帳號',
        new_password: '新密碼',
        password_confirmation: '再次輸入密碼',
        code: '啟用碼',
      },
      reset_success: {
        sub_title: '已成功重設密碼!',
        content_line1: '密碼已更改，',
        content_line2: '請使用帳號 {{loginId}} 以作登入。',
      },
    },
    change_password: {
      label: '更改密碼',
      description: '* 密碼宇元僅限於 6 到 10 個碼',
      current: '現有密碼',
      new: '新密碼',
      confirm_new: '再次輸入密碼',
      success_message: '密碼已成功更改。',
    },
    statement: {
      total_portfolio_value_alert:
        '商品プロバイダーからのデータ提供にて不具合が生じた為、運用報告書が表示できておりません。 ご迷惑をおかけして申し訳ございませんが、問題が解決するまで暫くお時間頂戴できます様お願い致します。',
    },
    report: {
      reports: '管理報表',
      product_type: '產品種類',
      exclude: '搜尋結果不包含',
      month: '月',
      type: '服務種類',
      to: '至',
      lapsed_surrender_date: '保單中斷 / 贖回日期 (YYYY/MM/DD)',
      transfer_in_effective_date: '轉入客戶生效日期 (YYYY/MM/DD)',
      sr_created_date: '服務紀錄新增日期 (YYYY/MM/DD)',
      cc_expiry_date: '信用卡到期日 (YYYY/MM)',
      received_date: '收到日期 (YYYY/MM/DD)',
      date_attened: 'Date Attened (YYYY/MM/DD)',
      export: '滙出至Excel',
    },
  },
};

export default commonZh;
